import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-yen', 'CurrencyYen', [["path",{"d":"M12 19v-7l-5 -7m10 0l-5 7"}],["path",{"d":"M8 17l8 0"}],["path",{"d":"M8 13l8 0"}]]);